import * as d3 from "d3";
import * as d3Format from "d3-format";
import socio from "../../../../data/socio";

const normal = (d) =>
  d.toLowerCase().split("'").join("").split(" ").join("").split("/")[0].trim();

const renderScatterplot = (data, mode, selectedNeighborhood, mobile) => {
  d3.select("#scatterplot svg svg").remove();
  d3.select("#scatterplot .tool_tip").remove();
  d3.selectAll("#scatterplot_labels p").remove();

  // const dots = Array.from(
  //   d3.rollup(
  //     data.filter((d) => d.communityarea && socio[normal(d.communityarea)]),
  //     (v) => {
  //       if (!socio[normal(v[0].communityarea)]) {
  //         console.log("Input error for:", v[0].communityarea);
  //       }
  //       return {
  //         v: v,
  //       };
  //     },
  //     (d) => d.communityarea
  //   )
  // );
  // console.log("dots", dots);

  const dots = Array.from(
    d3.rollup(
      data,
      (v) => {
        return {
          ratio:
            (v.length / +socio[normal(v[0].communityarea)].population) * 10000,
          graduation:
            100 -
            +socio[normal(v[0].communityarea)]["less than high school diploma"],
          income: +socio[normal(v[0].communityarea)]["median income"],
          unemployment: +socio[normal(v[0].communityarea)]["unemployment rate"],
        };
      },
      (d) => d.communityarea
    )
  );

  const margin = { top: 10, right: 10, bottom: 10, left: 20 },
    width = 500 - margin.left - margin.right,
    height = mobile
      ? 500 - margin.top - margin.bottom
      : 300 - margin.top - margin.bottom,
    x = d3
      .scaleLinear()
      .domain(d3.extent(dots, (d) => d[1][mode]))
      .range([0, width]),
    y = d3
      .scaleLinear()
      .range([height, 0])
      .domain([0, d3.max(dots, (d) => d[1].ratio)])
      .nice();

  const svg = d3
    .select("#scatterplot svg")
    .append("svg")
    .append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  const tooltip = d3.select("body").append("div").attr("class", "tool_tip");

  const yAxis = d3.axisLeft(y);
  yAxis
    .scale()
    .ticks(5)
    .map((d, i) => {
      d3.select("#scatterplot_y_labels")
        .append("p")
        .text(i === yAxis.scale().ticks(5).length - 1 ? d + " homicides" : d)
        .style("top", (y(d) / height) * 100 + "%");
    });

  const xAxis = d3
    .axisBottom(x)
    .ticks(4)
    .tickFormat((d) =>
      mode === "income" ? d3Format.format("$,")(d) : d + "%"
    );
  xAxis
    .scale()
    .ticks(5)
    .map((d) => {
      const medText = mode === "income" ? d3Format.format("$,")(d) : d + "%";
      d3.select("#scatterplot_x_labels")
        .append("p")
        .text(medText)
        .style("left", (x(d) / width) * 100 + "%");
    });

  svg
    .append("text")
    .attr("x", width / 2)
    .attr("y", height + 35)
    .text(mode)
    .style("font-weight", "bold")
    .style("text-anchor", "middle")
    .attr("font-size", 10);

  const medianVal = d3.median(dots, (d) => d[1][mode]);
  svg
    .append("line")
    .attr("y1", 5)
    .attr("y2", height)
    .attr("x1", x(medianVal))
    .attr("x2", x(medianVal))
    .attr("stroke-width", 1)
    .attr("stroke", "#000");

  d3.select("#scatterplot_median_label")
    .append("p")
    .style("left", (x(medianVal) / width) * 100 + "%")
    .style("top", "-2%")
    .html(() => {
      const medText =
        mode === "income"
          ? d3Format.format("$,")(medianVal.toFixed(0))
          : medianVal + "%";
      return `median<br/>${medText}`;
    });

  svg
    .selectAll(".dot")
    .data(dots)
    .enter()
    .append("circle")
    .attr("class", "dot")
    .attr("r", 5)
    .attr("cx", (d) => x(d[1][mode]))
    .attr("cy", (d) => y(d[1].ratio))
    .style("fill", "red")
    .style("fill-opacity", "0.35");

  if (selectedNeighborhood) {
    const selNeighborhood = dots.filter((d) => {
      return normal(d[0]) == normal(selectedNeighborhood);
    })[0];
    svg
      .selectAll(".seldot")
      .data(dots.filter((d) => normal(d[0]) == normal(selectedNeighborhood)))
      .enter()
      .append("circle")
      .attr("class", "seldot")
      .attr("r", 5)
      .attr("cx", (d) => x(d[1][mode]))
      .attr("cy", (d) => y(d[1].ratio))
      .style("fill", "rgba(0,0,0,0)")
      .style("stroke", "#000");

    d3.select("#scatterplot_neighborhood_label")
      .append("p")
      .text(selectedNeighborhood)
      .style("left", (x(selNeighborhood[1][mode]) / width) * 100 + "%")
      .style("top", (y(selNeighborhood[1].ratio) / height) * 100 + "%");
  }

  svg
    .selectAll(".overlay")
    .data(dots)
    .enter()
    .append("circle")
    .attr("class", "overlay")
    .attr("r", 5)
    .attr("cx", (d) => x(d[1][mode]))
    .attr("cy", (d) => y(d[1].ratio))
    .style("fill", "rgba(0,0,0,0")
    .on("mouseleave", () => tooltip.style("display", "none"))

    .on("mousemove", (event, d) => {
      const demographicText =
        mode === "income"
          ? d3Format.format("$,")(d[1][mode])
          : d[1][mode] + "%";
      tooltip
        .style("display", "inline-block")
        .html(
          `<div><p>${d[0]}</p><p>homicides: ${d[1].ratio.toFixed(
            1
          )} per 10,1000</p><p>${mode}: ${demographicText}</p></div>`
        );
      tooltip.style("top", event.pageY + 10 + "px");
      tooltip.style("left", event.pageX + 10 + "px");
    });
};

export default renderScatterplot;
